import { useInView } from "react-intersection-observer"
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

const Categorydescription = ({ styles, categoryFAQs, categorydescription }) => {

  const { ref: categoryDescriptionRef, inView: categoryDescriptionView } = useInView({
    threshold: 0,
    triggerOnce: true,
    rootMargin: "0px 0px 300px 0px"
  })

  return (
    <div ref={categoryDescriptionRef} className={styles.wrap_categories_row}>
      {categoryDescriptionView ? (
        <>
          {categorydescription && (
            <div
              className={styles.category_product_colm}
              dangerouslySetInnerHTML={{
                __html: categorydescription,
              }}
            />
          )}

          <div className="accordion pdp_faq" id="accordionExample">
            {categoryFAQs?.length > 0 && <h2 className={styles.faq_title}>Frequently Asked Questions (FAQs)</h2>}
            {categoryFAQs?.map((askkama, index) => (
              <Accordion defaultExpanded={true} key={index}>
                <AccordionSummary
                  expandIcon="+"
                  aria-label="Expand"
                  aria-controls="additional-actions1-content"
                  id="additional-actions1-header"
                  className={styles.ques}
                >
                  {askkama.question}
                </AccordionSummary>

                <AccordionDetails
                  className={styles.ans}
                >
                  {askkama.admin_answer}
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </>
      ) : null}
    </div>
  )
}

export default Categorydescription